let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9CAaE")).then(() => parcelRequire('2SnNI'));